import clsx from 'clsx';
import { useMemo } from 'react';

import CoreIcon from '../icon/icon';
import { convertSchemeNameToColors } from '../shared/lib/color-scheme-utils';
import { CoreTagProps } from '../shared/types/tag.types';

import styles from './tag.module.scss';

const coreTagPrefix = 'core-tag-';

function CoreTag({
  iconPosition = 'leading',
  icon,
  isClickable = false,
  hasBorder = true,
  size = 'small',
  label,
  clickHandler,
  schemeName = 'primary',
  extendedAnchorProps,
}: CoreTagProps) {
  const scheme = useMemo(
    () => convertSchemeNameToColors(schemeName),
    [schemeName]
  );

  const tagClass = clsx(
    styles['core-tag'],
    styles[coreTagPrefix + size],
    styles[coreTagPrefix + iconPosition],
    hasBorder && styles[coreTagPrefix + 'bordered'],
    isClickable && styles[coreTagPrefix + 'clickable']
  );

  const schemeStyle = {
    backgroundColor: scheme?.background,
    color: scheme?.foreground.primary,
    borderColor: hasBorder ? scheme?.foreground.primary : 'transparent',
  };

  const content = (
    <>
      {icon && <CoreIcon {...icon} size="xsmall" ariaHidden />}
      <span className={styles['core-tag-label']}>{label}</span>
    </>
  );

  const TagElement = isClickable ? 'a' : 'span';

  return (
    <div className={styles['core-tag-container']}>
      <TagElement
        className={tagClass}
        style={schemeStyle}
        onClick={isClickable ? clickHandler : undefined}
        tabIndex={isClickable ? 0 : undefined}
        {...(isClickable ? extendedAnchorProps : {})}
      >
        {content}
      </TagElement>
    </div>
  );
}

export default CoreTag;
